/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_density_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword density`)
};

const es_wc_density_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Densidad de palabras clave`)
};

const de_wc_density_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüsselwortdichte`)
};

const nl_wc_density_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trefwoorddichtheid`)
};

const fr_wc_density_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Densité des mots-clés`)
};

const it_wc_density_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Densità di parole chiave`)
};

const pt_br2_wc_density_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Densidade de palavras-chave`)
};

const pt_wc_density_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Densidade de palavras-chave`)
};

const ja_wc_density_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーワード密度`)
};

const zh_wc_density_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关键词密度`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_density_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_density_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_density_title", locale)
	if (locale === "en") return en_wc_density_title(inputs)
	if (locale === "es") return es_wc_density_title(inputs)
	if (locale === "de") return de_wc_density_title(inputs)
	if (locale === "nl") return nl_wc_density_title(inputs)
	if (locale === "fr") return fr_wc_density_title(inputs)
	if (locale === "it") return it_wc_density_title(inputs)
	if (locale === "pt-BR") return pt_br2_wc_density_title(inputs)
	if (locale === "pt") return pt_wc_density_title(inputs)
	if (locale === "ja") return ja_wc_density_title(inputs)
	return zh_wc_density_title(inputs)
};